export default "__VITE_ASSET__Cqf_mzVe__"